import { render } from "./Services.vue?vue&type=template&id=5782679e&scoped=true"
import script from "./Services.vue?vue&type=script&lang=js"
export * from "./Services.vue?vue&type=script&lang=js"

import "./Services.vue?vue&type=style&index=0&id=5782679e&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\WbPortfolio\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5782679e"]])

export default __exports__